export enum HomeProfileCardType {
    PersonalStats = "PersonalStats",
    RankBoard = "RankBoard"
  }